export const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register(
        `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`
      )
      console.log("Service worker registered successfully:", registration)
    } catch (error) {
      console.error("Service worker registration failed:", error)
    }
  } else {
    console.warn("Service workers are not supported in this browser.")
  }
}
